
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M6.131 0a2.05 2.05 0 00-2.04 2.04v.687H0v1.364h1.364v11.59c0 1.125.921 2.046 2.045 2.046h8.182a2.053 2.053 0 002.045-2.045V4.09H15V2.727h-4.09V2.04A2.05 2.05 0 008.868 0H6.131zm0 1.364h2.738c.383 0 .676.293.676.676v.687h-4.09V2.04c0-.383.293-.676.676-.676zM2.727 4.09h9.546v11.59a.673.673 0 01-.682.683H3.409a.673.673 0 01-.682-.682V4.09zm1.364 1.364V15h1.364V5.455H4.09zm2.727 0V15h1.364V5.455H6.818zm2.727 0V15h1.364V5.455H9.545z"}})])
          )
        }
      }
    